import { Row } from '@tanstack/react-table';
import { UpstreamEvent } from 'client';

import { formatDate } from 'utils/helpers';

type Props = {
  row: Row<UpstreamEvent>;
};

export function Updated({ row }: Props) {
  const date = row.original.updated_at;
  if (!date) return <>–</>;
  const dateStr = typeof date === 'string' ? date : date.toISOString();
  return <>{formatDate(dateStr, 'numeric', '2-digit', '2-digit')}</>;
}
